/* eslint-disable no-unused-vars */
/* eslint-disable no-console */

import React, { useContext, useState } from "react";
import { Title, useNotify } from "react-admin";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { apiUrl } from "../../constants";
import Registrations from "./registrations";
import PassSelection from "./passSelection";
import { EventContext } from "../../dataprovider/eventProvider";
import Live from "./live";
import QrCheck from "./qr";
import { mS } from "../../utils";
import { DelegateProvider } from "./context";
import { markDelegate } from "./indexDbUtils";
import ReSyncButton from "./reSyncButton";
import { htmlTemplate } from "./htmlTemplate";

const ScanUtility = () => {
  const [data, setData] = useState([]);

  const [open, setOpen] = useState();
  const [reload, setReload] = useState(false);
  const [tab, setTab] = useState("live");

  const notify = useNotify();

  const [details, setDetails] = useState({});
  const { currentEvent } = useContext(EventContext);

  const onConfirmPass = (info) => {
    setReload(true);
    setDetails(info);
    setTimeout(() => {
      setReload(false);
    }, 1000);
  };

  const confirmDelegate = (id, confirmed) =>
    markDelegate({ id, pass: details.pass, confirmed, eventId: currentEvent.id })
      .then((response) => {
        const { data: delegate, scanned, notConfirmed } = response;
        setData(delegate.rows);
        if (scanned) {
          notify("Already Scanned", {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
          return null;
        }
        if (notConfirmed) {
          notify("Not Verfied", {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
          return null;
        }
        const [row] = delegate?.rows || [{}];
        if (details.allowPrinting) {
          printLabel(row);
        }
        if (!details.allowPrinting) {
          notify("Delegate Scanned Successfully.", {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
        }
        return null;
      })
      .catch((err) => {
        if (err.response?.data?.error) {
          notify(`${err.response?.data?.error}`, { type: "warning" });
        } else {
          notify(`INVALID QR ${err.message}`, { type: "warning" });
        }
      });

  const printLabel = (info) => {
    if (currentEvent?.labelPrintUrl) {
      const printWindow = window.open("", "_blank");
      const htmlContent = htmlTemplate
        .replace("#DELEGATE_NAME#", `${info.firstName} ${info.lastName}`)
        .replace("#DELEGATE_COMPANY#", info.company)
        .replace("#DELEGATE_URL#", encodeURI(`${apiUrl}/${info.shortId}/d`))
        .replace("#DELEGATE_PASSES#", info.passes?.join("<br />") || "");
      printWindow.document.write(htmlContent);
      printWindow.document.close();
    }
  };

  return (
    <DelegateProvider details={details} eventKey={`${currentEvent.id}_${details.pass}`}>
      <Title
        title={
          details.pass ? (
            <>
              Scanning for: {details.pass}
              <IconButton
                aria-label="delete"
                size="small"
                onClick={() => {
                  setOpen(true);
                }}
                sx={{ alignSelf: "center", ml: mS && 1 }}
              >
                <EditIcon sx={{ color: "#000", height: mS ? "20px" : "15px" }} />
              </IconButton>
            </>
          ) : (
            <>Select a Pass</>
          )
        }
      />
      {details.pass ? (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
            <Tabs
              value={tab}
              indicatorColor="primary"
              onChange={(e, value) => {
                setTab(value);
              }}
            >
              <Tab label="LIVE" value="live" />
              <Tab label="SCAN QR" value="qr" />
              <Tab label="SEARCH" value="search" />
            </Tabs>
          </div>

          {tab === "live" && <Live details={details} setTab={setTab} />}
          {tab === "qr" && (
            <QrCheck
              details={details}
              reload={reload}
              data={data}
              confirmDelegate={confirmDelegate}
              printLabel={printLabel}
            />
          )}
          {tab === "search" && (
            <Registrations
              confirmDelegate={confirmDelegate}
              printLabel={printLabel}
              eventKey={`${currentEvent.id}_${details.pass}`}
            />
          )}
        </>
      ) : (
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          <Grid item lg={3} xs={10} sx={{ textAlign: "center" }}>
            <Button
              variant="contained"
              component="label"
              size="large"
              sx={{ width: "100%", minHeight: "100px" }}
              onClick={() => setOpen(true)}
            >
              Select Pass
            </Button>
          </Grid>
        </Grid>
      )}
      <PassSelection open={open} setOpen={setOpen} onConfirm={onConfirmPass} />

      <ReSyncButton />
    </DelegateProvider>
  );
};

export default ScanUtility;
